<template lang="pug">
app-button(
  color="redesignPrimaryDarken"
  rounded
  block
  v-bind="$attrs"
  v-on="$listeners"
)
  v-icon.mr-1 $i-telegram
  span Войти через Телеграм
</template>

<script>
export default {
  name: 'TelegramSignInButton',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
